import { lazy, type ComponentType } from "react";

/**
 * lazy() wrapper that retries a failed dynamic import once after a short delay.
 * Network blips on first navigation (especially on slow connections or after a
 * new deploy) otherwise bubble up to the ErrorBoundary as "something went wrong".
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  retries = 1,
  delayMs = 400,
) {
  return lazy(async () => {
    let lastError: unknown;
    for (let attempt = 0; attempt <= retries; attempt++) {
      try {
        return await factory();
      } catch (err) {
        lastError = err;
        if (attempt < retries) {
          await new Promise((r) => setTimeout(r, delayMs));
        }
      }
    }
    throw lastError;
  });
}
